import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import AddQuotePageStore, {
  AddQuotePageStoreContext,
  useAddQuotePageStore,
} from 'store/pages/quote/add-quote/pageStore';
import AddQuotePageContent from 'components/quote/add-quote';

// First iteration of the Add Quote page, built on top of the existing Proposal page components.
// To preserve the required behavior and support legacy proposal flows, this version reuses the proposalItemsStore.
// The page will be fully redesigned across design, FE, and BE in future iterations.

const PageContent: React.FC = observer(() => {
  const { flowDelegate, isActionLoading, canCompleteStep, getInitialData, onComplete } = useAddQuotePageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.INITIATE_SHELF_ADD_QUOTE}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Release',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <AddQuotePageContent />
    </QuoteFlowLayout>
  );
});

const AddQuotePage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const pageStore = useMemo(() => new AddQuotePageStore({ groupId, periodId, cartId }), []);

  return (
    <AddQuotePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AddQuotePageStoreContext.Provider>
  );
};

export default AddQuotePage;
